<script setup lang="ts">
  import { PageDecorationImage } from '@/shared/ui/components'

  import { NewsList } from '@/views/news'

  definePage({
    meta: { layout: 'baseNew' },
  })

  const { t } = useI18n()

  useHead({
    title: () => t('navigation_item_news'),
  })
</script>

<template>
  <div class="wide-responsive relative w-full">
    <div class="border-border bg-surface-bg relative w-full border-b px-6 pt-8 pb-6">
      <h1 class="heading-md text-heading!">
        {{ $t('navigation_item_news') }}
      </h1>

      <PageDecorationImage />
    </div>
    <NewsList />
  </div>
</template>
